<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Transport Execution Details</b-navbar-brand>
          <b-navbar-brand center
            ><b-button
              :variant="Filter.VehicleNofilter ? 'outline-danger' : 'outline-primary'"
              :class="'ml-4' + visible ? null : 'collapsed'"
              :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4"
              style="font-size: 0.675rem"
              size="sm"
              @click="visible = !visible"
              >{{ Filter.VehicleNofilter ? "Filter ON" : "Filter OFF" }}</b-button
            ></b-navbar-brand
          >
        </b-navbar>

        <div v-if="visible" class="mb-2">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input
                        :formatter="capitalizeAll"
                        v-model="Filter.VehicleNofilter"
                        @input="getVehicleAssignmentData"
                        placeholder="Type To Search for Vehicle No Filter"
                      />
                      <CustomLoader v-if="iscolLoading" :width="70"></CustomLoader>
                      <b-input-group-append>
                        <b-button
                          :disabled="!Filter.VehicleNofilter"
                          size="sm"
                          style="margin-left: auto"
                          class="ml-1 pull-right"
                          @click="clearFilter"
                          variant="outline-danger"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row
                v-if="VehicleNoAssignmentDetails.allModuleId && Filter.VehicleNofilter"
              >
                <b-col
                  md="3"
                  v-if="VehicleNoAssignmentDetails.AssignmentDetails.tptType_Status"
                >
                  <b-button
                    v-if="VehicleNoAssignmentDetails.AssignmentDetails.assignId"
                    variant="outline-success"
                    size="sm"
                    @click="
                      goToTrack(VehicleNoAssignmentDetails.AssignmentDetails.assignId)
                    "
                    >Track Assignment</b-button
                  >
                </b-col>
                <b-col
                  md="3"
                  v-if="VehicleNoAssignmentDetails.AssignmentDetails.tptType_Status"
                >
                  <label
                    ><b>GRN Type :</b>
                    {{
                      VehicleNoAssignmentDetails.AssignmentDetails.tptType_Status
                    }}</label
                  >
                </b-col>
                <b-col md="3" v-if="VehicleNoAssignmentDetails.AssignmentDetails.GRNNo">
                  <label
                    ><b>GRN NO :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.GRNNo }}</label
                  >
                </b-col>
                <b-col md="3" v-if="VehicleNoAssignmentDetails.AssignmentDetails.GRNDate">
                  <label
                    ><b>GRN Date :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.GRNDate }}</label
                  >
                </b-col>
                <b-col
                  md="3"
                  v-if="VehicleNoAssignmentDetails.AssignmentDetails.GRNCounter"
                >
                  <label
                    ><b>GRN Counter :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.GRNCounter }}</label
                  >
                </b-col>
                <b-col
                  md="3"
                  v-if="VehicleNoAssignmentDetails.AssignmentDetails.GRRasiedBy"
                >
                  <label
                    ><b>GRN Created By :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.GRRasiedBy }}</label
                  >
                </b-col>
                <b-col
                  md="3"
                  v-if="
                    VehicleNoAssignmentDetails.AssignmentDetails.multipleContainerType
                  "
                >
                  <label
                    ><b>Container Type :</b>
                    {{
                      VehicleNoAssignmentDetails.AssignmentDetails.multipleContainerType
                    }}</label
                  >
                </b-col>
                <b-col
                  md="3"
                  v-if="VehicleNoAssignmentDetails.AssignmentDetails.containerNo"
                >
                  <label
                    ><b>Container No :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.containerNo }}</label
                  >
                </b-col>

                <b-col
                  md="3"
                  v-if="VehicleNoAssignmentDetails.AssignmentDetails.vehicleType"
                >
                  <label
                    ><b>Vehicle Type :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.vehicleType }}</label
                  >
                </b-col>
                <b-col
                  md="3"
                  v-if="VehicleNoAssignmentDetails.AssignmentDetails.vehicleNo"
                >
                  <label
                    ><b>Vehicle No :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.vehicleNo }}</label
                  >
                </b-col>
                <b-col
                  md="3"
                  v-if="VehicleNoAssignmentDetails.AssignmentDetails.VehicleStatus"
                >
                  <label
                    ><b>Vehicle Status :</b>
                    {{
                      VehicleNoAssignmentDetails.AssignmentDetails.VehicleStatus
                    }}</label
                  >
                </b-col>

                <b-col md="3" v-if="VehicleNoAssignmentDetails.AssignmentDetails.JobType"
                  ><label
                    ><b>Job Type :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.JobType }}</label
                  ></b-col
                >
                <b-col md="3" v-if="VehicleNoAssignmentDetails.AssignmentDetails.JobNo"
                  ><label
                    ><b>Job No :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.JobNo }}</label
                  ></b-col
                >
                <b-col md="3" v-if="VehicleNoAssignmentDetails.AssignmentDetails.JobDate"
                  ><label
                    ><b>Job Date :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.JobDate }}</label
                  ></b-col
                >
                <b-col md="3" v-if="VehicleNoAssignmentDetails.AssignmentDetails.RasiedBy"
                  ><label
                    ><b>Job Created By :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.RasiedBy }}</label
                  ></b-col
                >

                <b-col md="3" v-if="VehicleNoAssignmentDetails.AssignmentDetails.MBLNO"
                  ><label
                    ><b>MBL :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.MBLNO }}</label
                  ></b-col
                >
                <b-col md="3" v-if="VehicleNoAssignmentDetails.AssignmentDetails.HBLNO"
                  ><label
                    ><b>HBL :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.HBLNO }}</label
                  ></b-col
                >
                <b-col
                  md="3"
                  v-if="VehicleNoAssignmentDetails.AssignmentDetails.transportType"
                  ><label
                    ><b>Transport Type :</b>
                    {{
                      VehicleNoAssignmentDetails.AssignmentDetails.transportType
                    }}</label
                  ></b-col
                >
                <b-col
                  md="3"
                  v-if="VehicleNoAssignmentDetails.AssignmentDetails.sob_date_detected"
                >
                  <label
                    ><b>SOB Date :</b>
                    {{
                      VehicleNoAssignmentDetails.AssignmentDetails.sob_date_detected
                    }}</label
                  >
                </b-col>
                <b-col
                  md="3"
                  v-if="VehicleNoAssignmentDetails.AssignmentDetails.vessel_voyage"
                >
                  <label
                    ><b>Vessel Voyage :</b>
                    {{
                      VehicleNoAssignmentDetails.AssignmentDetails.vessel_voyage
                    }}</label
                  >
                </b-col>
                <b-col
                  md="3"
                  v-if="VehicleNoAssignmentDetails.AssignmentDetails.RasiedFrom"
                >
                  <label
                    ><b>Branch :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.RasiedFrom }}</label
                  >
                </b-col>

                <b-col
                  md="3"
                  v-if="VehicleNoAssignmentDetails.AssignmentDetails.clientName"
                >
                  <label
                    ><b>Client :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.clientName }}</label
                  >
                </b-col>
                <b-col
                  md="3"
                  v-if="VehicleNoAssignmentDetails.AssignmentDetails.ShippingLine"
                >
                  <label
                    ><b>Shipping Line :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.ShippingLine }}</label
                  >
                </b-col>
                <b-col md="3" v-if="VehicleNoAssignmentDetails.AssignmentDetails.PICK">
                  <label
                    ><b>Pickup :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.PICK }}</label
                  >
                </b-col>
                <b-col md="3" v-if="VehicleNoAssignmentDetails.AssignmentDetails.HAND">
                  <label
                    ><b>Handover :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.HAND }}</label
                  >
                </b-col>
                <b-col md="3" v-if="VehicleNoAssignmentDetails.AssignmentDetails.STUFF">
                  <label
                    ><b>Stuffing :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.STUFF }}</label
                  >
                </b-col>
                <b-col md="3" v-if="VehicleNoAssignmentDetails.AssignmentDetails.POR">
                  <label
                    ><b>POR :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.POR }}</label
                  >
                </b-col>
                <b-col md="3" v-if="VehicleNoAssignmentDetails.AssignmentDetails.POL">
                  <label
                    ><b>POL :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.POL }}</label
                  >
                </b-col>
                <b-col md="3" v-if="VehicleNoAssignmentDetails.AssignmentDetails.POD">
                  <label
                    ><b>POD :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.POD }}</label
                  >
                </b-col>
                <b-col md="3" v-if="VehicleNoAssignmentDetails.AssignmentDetails.FPOD">
                  <label
                    ><b>FPOD :</b>
                    {{ VehicleNoAssignmentDetails.AssignmentDetails.FPOD }}</label
                  >
                </b-col>
              </b-row>
              <b-row
                v-else-if="
                  !VehicleNoAssignmentDetails.allModuleId && Filter.VehicleNofilter
                "
                ><b-col md="12"><strong>Data Not Found !!!!</strong></b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>

        <div class="box">
          <md-layout md-gutter>
            <md-layout md-flex="80">
              <b-form-input
                :formatter="capitalizeAll"
                v-model="filter"
                placeholder="Search  Execution No./Booking/BL No./BOE"
                @input="debounceSearch"
              ></b-form-input>
            </md-layout>
            <md-layout md-flex="20">
              <model-list-select
                @input="viewQuotation('0', '1', '1')"
                :list="dateStatusList"
                v-model="dateStatusFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select Date Filter"
              ></model-list-select>
            </md-layout>
          </md-layout>
           <b-row>
         <b-col md="3">
            <label>Vehicle Status</label>
            <model-list-select :list="VehicleStatusList" v-model="vehicleStatusFilter" 
              option-value="val" option-text="status" placeholder="Select Vehicle Status"
              @input="viewQuotation('0', '1', '1')"
              />
          </b-col>
        </b-row>
          <div>
            <h5 class="text-muted pull-right mt-2">
              <small>{{ totalRows }} Entries</small>
            </h5>
          </div>
          <div class="table-responsive tableMain mt-2">
            <b-table
              show-empty
              stacked="md"
              :items="veiwQuotationForm"
              :fields="fields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <template slot="quotationId" slot-scope="row0">
                <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              </template>
              <template slot="mainSalesSeries" slot-scope="row1">
                <b-badge v-if="row1.item.seenExec == '0'" variant="danger"
                  >New
                  <br />
                </b-badge>

                <b
                  class="showMoreData"
                  @click="
                    row1.item.is_locked == '1' &&
                    (row1.item.finalBillingCompleted == 1 ||
                      row1.item.locked_counter > 0) &&
                    $sessionsStorage.get('designation') != 'Admin' &&
                    $sessionsStorage.get('nameUser') != 'Bhavneesh'
                      ? ''
                      : viewQuotationpage(
                          row1.item.clientId,
                          row1.item.salesBookingId,
                          row1.item.quotationId,
                          row1.item.assignId,
                          row1.item.expireStatus,
                          row1.item
                        )
                  "
                  :style="row1.item.seenExec == '0' ? 'color:red' : 'color:black'"
                  >{{ row1.item.mainSalesSeries }}</b
                >
                <br />

                <span>Generated On : {{ row1.item.loginTime | moment }}</span>
                <br />
                <span>
                  Valid Till : {{ row1.item.validityDate | moment }}
                  <br />
                </span>
                <span style="color: green" v-if="row1.item.additionalAssignmentNo"
                  >Additional Assignment :<b>
                    {{ row1.item.additionalAssignmentNo }}</b
                  ></span
                >
                <div
                  v-if="
                    row1.item.containerAdded != '' && row1.item.containerAdded != null
                  "
                >
                  <h6
                    v-if="
                      row1.item.totalContainer !=
                      row1.item.containerAdded.split(',').length
                    "
                  >
                    <b-badge variant="info">Incomplete Execution</b-badge>
                  </h6>
                </div>
                <div v-else>
                  <h6>
                    <b-badge variant="info">Incomplete Execution</b-badge>
                  </h6>
                </div>

                <div v-if="row1.item.vehicleReleaseDateAdded">
                  <h6
                    v-if="
                      !row1.item.vehicleReleaseDateAdded.split(',').includes('0') &&
                      row1.item.totalContainer ==
                        row1.item.vehicleReleaseDateAdded.split(',').length
                    "
                  >
                    <b-badge variant="success">Execution Done</b-badge>
                  </h6>
                </div>
                <b-button
                  style="font-size: 0.675rem"
                  class="mt-2"
                  size="sm"
                  @click="
                    row1.item.is_locked == '1' &&
                    (row1.item.finalBillingCompleted == 1 || row1.item.locked_counter > 0)
                      ? LockUnLock(row1.item, 'locked')
                      : ''
                  "
                  :variant="
                    row1.item.is_locked == '1' &&
                    (row1.item.finalBillingCompleted == 1 || row1.item.locked_counter > 0)
                      ? 'danger'
                      : 'success'
                  "
                  ><b
                    v-if="
                      row1.item.is_locked == '1' &&
                      (row1.item.finalBillingCompleted == 1 ||
                        row1.item.locked_counter > 0)
                    "
                    ><i class="fa fa-lock mr-1 lg"></i>LOCKED</b
                  ><b v-else><i class="fa fa-unlock mr-1 lg"></i>UN-LOCKED</b></b-button
                ><br />
                <b-button
                  size="sm"
                  @click="showDocModal(row1.item)"
                  variant="outline-dark"
                  >Summary & Documents</b-button
                >
                <Assignment-Summary
                  :title="'Shipment Summary Tracking - '"
                  :fk_all_module_id="row1.item.allModuleId"
                  :jb_series="row1.item.mainSalesSeries"
                />
                <!-- <JobWisePaymentsDetails
                  v-if="row1.item.allModuleId"
                  :allModuleId="Number(row1.item.allModuleId)"
                  :JobNo="row1.item.mainSalesSeries"
                  /> -->
                <ContainerSummary
                  v-if="row1.item.allModuleId"
                  :PMC_title="'Container Summary Job No - ' + row1.item.mainSalesSeries"
                  :PMC_JOBID="row1.item.allModuleId"
                  :PMC_JOBNO="row1.item.mainSalesSeries"
                  :PMC_JOBDATE="''"
                  :PMC_JOBTYPE="''"
                  :PMC_AgentType="''"
                  :PMC_Client="''"
                  :PMC_Sline="''"
                />
                <AssignmentSplitMergeSummary
                  v-if="row1.item.allModuleId"
                  :PMC_title="'Assignment Split/Merge/Move Summary Job No - ' + row1.item.mainSalesSeries"
                  :PMC_JOBID="row1.item.allModuleId"
                  :PMC_JOBNO="row1.item.mainSalesSeries"
                  :PMC_JOBDATE="''"
                  :PMC_JOBTYPE="''"
                  :PMC_AgentType="''"
                  :PMC_Client="''"
                  :PMC_Sline="''"
                />
                <!-- {{row1.item}} -->
                <Overseas-CRDRNote
                  v-if="row1.item.jobType.indexOf('FF') < 0"
                  :title="row1.item.mainSalesSeries"
                  :moduleType="'TPT ' + row1.item.transportType + ' Module'"
                  :cr_all_module_id="row1.item.allModuleId"
                  :cr_jb_series="row1.item.mainSalesSeries"
                  :cr_ass_date="row1.item.loginTime | moment"
                  :transportType="row1.item.transportType"
                  :Jobtype="'TPT'"
                  :commonId="row1.item.quotationId"
                  :shipmentType="
                    row1.item.shipmentType == '1' ||
                    row1.item.shipmentType == 'Sea_Shipment'
                      ? 'Sea'
                      : 'Air'
                  "
                  :isOverseas="false"
                  :ItemAr="null"
                />
                <MSDeleteRequest
                :item="row1.item"
                :JobNo="row1.item.mainSalesSeries"
                :JobID="row1.item.allModuleId"
                :sessionsStorage="$sessionsStorage"
                @refreshData="handleRefresh"
              />
              <b v-if="row1.item.deleteRequestBy != '' && row1.item.deleteRequestBy != '0' && row1.item.deleteRequestBy != null">Requested By : {{ row1.item.deleteRequestBy }}<br/></b>
              <b v-if="row1.item.deleteArrovedBy != '' && row1.item.deleteArrovedBy != '0' && row1.item.deleteArrovedBy != null">Arroved By : {{ row1.item.deleteArrovedBy }}<br/></b>
              
              </template>

              <template slot="clientName" slot-scope="row11">
                <b :style="row11.item.seenExec == '0' ? 'color:red' : 'color:black'">{{
                  row11.item.clientName
                }}</b>
              </template>
              <template slot="multipleContainerType" slot-scope="row11">
                <span>Container Type : {{ row11.item.multipleContainerType }}</span>
                <br />
                <span>
                  No. of Containers : {{ row11.item.multiConNo }}
                  <br />
                </span>
                <span
                  class="error"
                  v-if="
                    row11.item.containerAdded != '' && row11.item.containerAdded != null
                  "
                >
                  {{ row11.item.containerAdded }}
                  No. of Containers Executed :
                  {{ row11.item.containerAdded.split(",").length }}
                  <br />
                </span>
                <span class="error" v-else
                  >No. of Containers Executed : 0
                  <br />
                </span>
                <!-- {{row11.item}} -->
                <Add-Message
                  :fk_all_module_id="row11.item.allModuleId"
                  :fk_client_id="row11.item.clientId"
                  :fk_pod_id="row11.item.PODLocationId"
                  style="list-style-type: none"
                />
              </template>
              <!-- <template slot="isQuotationActive" slot-scope="row9">
                <b v-if="row9.item.asignDeleted=='1'" style="color:red">Assignment Deleted</b>
                <md-button
                  v-else
                  @click="viewQuotationpage(row9.item.clientId,row9.item.salesBookingId,row9.item.quotationId,row9.item.assignId,row9.item.expireStatus)"
                >
                  <a class="fa fa-pencil-square-o"></a>
                </md-button>
              </template>-->
            </b-table>
          </div>
        </div>
        <div>
          <h5>
            <b-pagination
              limit="5"
              align="center"
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              @change="onPageChange($event)"
            ></b-pagination>
          </h5>
        </div>
        <!-- Added By Priyanshu Singh For Billing Close Section Start -->
        <b-modal
          id="modal-lock-conf"
          ref="modal-lock-conf"
          title="Reason for Open Locked Assignment"
          centered
          no-close-on-esc
          no-close-on-backdrop
          hide-footer
        >
          <h3>Confirmation</h3>
          <form ref="form">
            <b-form-group
              label="Remark"
              label-for="name-input"
              invalid-feedback="Name is required"
            >
              <b-form-textarea
                :formatter="capitalizeAll"
                rows="5"
                id="name-input"
                v-model="lockReason"
                required
              ></b-form-textarea>
            </b-form-group>
          </form>

          <b-button @click="closeLockUnLockConfirm" variant="danger"> Cancel</b-button>
          <b-button
            v-if="lockReason"
            :disabled="lock_button ? true : false"
            variant="success"
            class="pull-right"
            @click="ConfLock"
            >Send</b-button
          >
        </b-modal>
        <md-dialog-confirm
          :md-content-html="alert.content"
          :md-ok-text="alert.ok"
          ref="addPop"
        ></md-dialog-confirm>
        <div>
          <b-modal
            size="xl"
            class="modal-dialog-doc"
            no-close-on-esc
            no-close-on-backdrop
            ref="doc-modal"
            hide-footer
            :title="'Assignment Summary & Documents - ' + JOBSERIES"
          >
            <div v-if="ALLMODULE">
              <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
            </div>
            <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
              >Close
            </b-button>
          </b-modal>
        </div>
        <!-- Added By Priyanshu Singh For Billing Close Section End -->
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import DatePicker from "vue2-datepicker";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../../helper/collection";
import DocForm from "../../allModuleForm/docLibrary.vue";
import AddMessage from "../../allModuleForm/addMessage.vue";
import AssignmentSummary from "../../common/assignmentSummary.vue";
import OverseasCRDRNote from "../../common/overseasCRDRNote.vue";
import TrasportService from "../../../services/TrasportService.js";
import ContainerSummary from "../../common/moduleBasedContaierSummary.vue";
import AssignmentSplitMergeSummary from "../../common/AssignmentSplitMergeSummary.vue";
import JobWisePaymentsDetails from "../../common/jobWisePaymentsDetails.vue";
import MSDeleteRequest from "../../common/MSDeleteRequest.vue";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    if (globalPermissionStatus("Transportation")) {
      this.$store.dispatch("setCurrentRoute", "/listView/viewQuotation");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewQuotation("0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      vehicleStatusFilter: "3",
      VehicleStatusList: [
        {
          status: "IN TRANSIT",
          val: "1",
        },
        {
          status: "CLOSED",
          val: "2",
        },
        {
          status: "ALL",
          val: "3",
        },
      ],
      Filter: { VehicleNofilter: "" },
      visible: false,
      VehicleNoAssignmentDetails: {
        allModuleId: "",
      },

      ALLMODULE: "",
      JOBSERIES: "",
      lock_allModuleId: "",
      lock_ffExportFclId: "",
      lock_ffExportFclSeries: "",
      lock_Type: "",
      lockReason: "",
      lock_button: false,
      is_locked: "",
      locked_counter: "",
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },

      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      totalRows: 1000000000000000,
      currentPage: 1,
      perPage: 10,
      pageOptions: [20, 50, 100],
      sortBy: null,
      debounce: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      fields: [
        {
          key: "quotationId",
          mainkey: "quotationId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "mainSalesSeries",
          mainkey: "mainSalesSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
          table: "P.",
        },
        {
          key: "clientName",
          mainkey: "clientName",
          label: "Client / Shipper Name",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "PICK",
          mainkey: "PICK",
          label: "Pickup Location",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },

        {
          key: "STUFF",
          mainkey: "STUFF",
          label: "Factory Location",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "HAND",
          mainkey: "HAND",
          label: "Handover Location",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "multipleContainerType",
          mainkey: "multipleContainerType",
          label: "Container",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "validBookingNo",
          mainkey: "validBookingNo",
          label: "Booking / BL No.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "customBOE",
          mainkey: "customBOE",
          label: "BOE",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
      ],
      isLoading: false,
      iscolLoading: false,
      veiwQuotationForm: [],
      dateStatusFilter: "60",
      dateStatusList: [
        {
          inv: "60",
          int: "2 Month",
        },
        {
          inv: "90",
          int: "3 Month",
        },
        {
          inv: "125",
          int: "4 Month",
        },
        {
          inv: "186",
          int: "6 Month",
        },
        {
          inv: "248",
          int: "8 Month",
        },
        {
          inv: "300",
          int: "10 Month",
        },
        {
          inv: "367",
          int: "1 Year",
        },
        {
          inv: "734",
          int: "2 Year",
        },

        {
          inv: "0",
          int: "Global ALL",
        },
      ],
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() {},
  beforeDestroy() {
    this.$store.dispatch("setSelectedArray", "");
    this.$store.dispatch("setUnselectedArray", "");
    this.$store.dispatch("setFixArray", "");
  },
  destroyed() {},
  components: {
    ModelListSelect,
    // Loading,
    CustomLoader,
    DocForm,
    AddMessage,
    AssignmentSummary,
    OverseasCRDRNote,
    ContainerSummary,
    AssignmentSplitMergeSummary,
    JobWisePaymentsDetails,
    MSDeleteRequest,
  },
  computed: {},

  methods: {
    goToTrack(AId) {
      this.$sessionsStorage.set("storeAssignId", AId);
      this.$sessionsStorage.set("backToDetailPage", "22");
      this.$router.push({
        path: "/vehicleQuotation/tranportMailDetails",
      });
    },
    getVehicleAssignmentData() {
      this.VehicleNoAssignmentDetails = {};
      // this.iscolLoading = true;
      if (this.Filter.VehicleNofilter) {
        let paylod = {
          Filter: this.Filter,
          itemCode: "VehicleNoAssignmentDetails",
        };
        this.iscolLoading = true;
        TrasportService.getAllTrasportList(JSON.stringify(paylod))
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data.VehicleNoAssignmentDetails) {
              this.iscolLoading = false;
              this.VehicleNoAssignmentDetails = data.VehicleNoAssignmentDetails;
            }
          })
          .catch((error) => {
            console.log("Catch on getAllTrasportList Error: ", error);
          });
      }
    },
    clearFilter() {
      this.Filter = {
        VehicleNofilter: "",
      };
      this.VehicleNoAssignmentDetails = {};
    },
    ConfLock() {
      if (this.lockReason) {
        this.isLoading = true;
        let tit = "";
        if (this.is_locked == 1) {
          this.is_locked = "0";
          tit = "Un-Locked";
        } else if (this.is_locked == 1) {
          this.is_locked = "1";
          tit = "Locked";
        }
        this.lock_button = true;
        let payload = {
          allModuleId: this.lock_allModuleId,
          lockReason: this.lockReason,
          update_keyVal: this.lock_ffExportFclId,
          assigmnmentSeries: this.lock_ffExportFclSeries,
          Type: this.lock_Type,
          is_locked: this.is_locked,
          locked_counter: this.locked_counter,
          table_name: "quotationdetail",
          update_key: "quotationId",
          Title: tit,
          module_type: "TPT Export",
        };
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/locknnlockStatus.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.find == 1) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.$refs["addPop"].open();
              this.lock_button = false;
              this.viewQuotation("0", "1", "1");
              this.isLoading = false;
            }
            (this.lockReason = ""), this.$refs["modal-lock-conf"].hide();
          })
          .catch((error) => {});
      }
    },
    LockUnLock(items, type) {
      this.lock_allModuleId = items.allModuleId;
      this.lock_ffExportFclId = items.quotationId;
      this.lock_ffExportFclSeries = items.mainSalesSeries;
      this.lock_Type = type;
      this.is_locked = items.is_locked;
      this.locked_counter = items.locked_counter;
      console.log("Priyanshu Singh=>", items);
      // return false;
      this.$refs["modal-lock-conf"].show();
    },
    closeLockUnLockConfirm() {
      this.$refs["modal-lock-conf"].hide();
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.viewQuotation("0", "1", "1");

        // this.typing = null
        // this.message = event.target.value
      }, 1000);
    },
    showDocModal(item) {
      // console.log("Items=>",item)
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.mainSalesSeries;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewQuotation(CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewQuotation(CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },

    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    JqueryFun() {
      return $(function () {
        return $("#viewQuotationDetail").DataTable();
      });
    },

    getData(sort) {
      let body = {
        sorts,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/apis/dataTable.php`,
        data: JSON.stringify(body),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {})
        .catch((error) => {});
    },

    viewQuotationpage(clientId, salesid, quotationId, assignId, expireStatus, item) {
      if (assignId == "" || assignId == null) {
        this.$sessionsStorage.set("storeAssignId", "false");
      } else {
        this.$sessionsStorage.set("storeAssignId", assignId);
      }
      this.$sessionsStorage.set("clientId", clientId);
      this.$sessionsStorage.set("salesBookingId", salesid);
      this.$sessionsStorage.set("storeQuotationId", quotationId);
      this.$sessionsStorage.set("storeExpireStatus", expireStatus);

      if (item.seenExec == "0") {
        let paylod = {
          UpdateNotSeenToSeen: "yes",
          quotationId: quotationId,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/updateExecutionToSeenAllModules.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.$router.push({
                path: "/vehicle/quotation",
              });
              //  this.vehicleSizeMaster[this.indexNew] = this.itemObj;
            }
          })
          .catch((error) => {});
      } else {
        this.$router.push({
          path: "/vehicle/quotation",
        });
      }
    },

    handleRefresh() {
      this.viewQuotation("0", "1", "1");
    },
    viewQuotation(CURRENT, SEARCH, pageNumber) {
      this.isLoading = true;
      let view_Quotation = {
        searchVal: this.filter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        quotationNo: "quotationNo",
        dateStatusFilter: this.dateStatusFilter,
        optTypeTransport: this.$sessionsStorage.get("optTypeTransport")
          ? this.$sessionsStorage.get("optTypeTransport")
          : "",
        optAllModuleIdTransport: this.$sessionsStorage.get("optAllModuleIdTransport")
          ? this.$sessionsStorage
              .get("optAllModuleIdTransport")
              .replace(/^,/, "")
              .replace(/,$/, "")
          : "",
      vehicleStatusFilter: this.vehicleStatusFilter,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Transport/viewQuotationDetail.php`,
        data: JSON.stringify(view_Quotation),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.veiwQuotationForm = data.quotation;
            this.totalRows = data.totalData;
            console.log("data=>", data);
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }

            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// viewQuotation.vue?b733f908